import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const sell_requestApi = createAsyncThunk(
  "sell_request",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/sell_request", { params });
    return response.data;
  }
);

const sell_requestSlice = createSlice({
  name: "sell_request",
  initialState: {
    sell_request: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sell_requestApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sell_requestApi.fulfilled, (state, action) => {
        state.sell_request = action.payload;
        state.loading = false;
      })
      .addCase(sell_requestApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sell_requestSlice.reducer;
